import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import useDataCollection from '../../hooks/useDataCollection';
import './DataPeriodInfo.css';

const DataPeriodInfo = () => {
  const [availablePeriod, setAvailablePeriod] = useState(null);
  const { getProcessedDataForReports, getDataStats } = useDataCollection();

  // Cargar información del período disponible al montar el componente
  useEffect(() => {
    const loadAvailablePeriod = async () => {
      try {
        const realDataResult = getProcessedDataForReports(30);
        //const stats = getDataStats();
        
        if (realDataResult.hasRealData && realDataResult.realData.length > 0) {
          const realData = realDataResult.realData;
          setAvailablePeriod({
            days: realData.length,
            startDate: realData[0].date,
            endDate: realData[realData.length - 1].date,
            isRealData: true
          });
        } else {
          const today = new Date();
          const sevenDaysAgo = new Date();
          sevenDaysAgo.setDate(today.getDate() - 6);
          
          setAvailablePeriod({
            days: 7,
            startDate: format(sevenDaysAgo, 'yyyy-MM-dd'),
            endDate: format(today, 'yyyy-MM-dd'),
            isRealData: false
          });
        }
      } catch (error) {
        console.error('Error cargando período disponible:', error);
      }
    };
    
    loadAvailablePeriod();
  }, [getProcessedDataForReports, getDataStats]);

  return (
    <div className="data-period-info">
      <h3>Período de Datos</h3>
      {availablePeriod ? (
        <div className="period-details">
          <p className="period-text">
            <strong>{availablePeriod.days} días</strong> monitoreados
          </p>
          <p className="period-dates">
            {format(new Date(availablePeriod.startDate), 'dd/MM/yyyy', { locale: es })} - {' '}
            {format(new Date(availablePeriod.endDate), 'dd/MM/yyyy', { locale: es })}
          </p>
        </div>
      ) : (
        <div className="loading-period">
          <p>Verificando datos disponibles...</p>
        </div>
      )}
    </div>
  );
};

export default DataPeriodInfo;
